import { render, staticRenderFns } from "./AlertsMessagesListComponent.vue?vue&type=template&id=7e7becc0&scoped=true"
import script from "./AlertsMessagesListComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertsMessagesListComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AlertsMessagesListComponent.vue?vue&type=style&index=0&id=7e7becc0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7becc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e7becc0')) {
      api.createRecord('7e7becc0', component.options)
    } else {
      api.reload('7e7becc0', component.options)
    }
    module.hot.accept("./AlertsMessagesListComponent.vue?vue&type=template&id=7e7becc0&scoped=true", function () {
      api.rerender('7e7becc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AlertsMessages/AlertsMessagesListComponent.vue"
export default component.exports